import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';

import { ITab } from './tab.types';
import { find, isEqual, isString } from 'lodash';

@Component({
  selector: 'xea-tab-switch',
  templateUrl: './tab-switch.component.html',
  styleUrls: ['./tab-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TabSwitchComponent implements OnInit {
  @Input() public tabs: ITab[];

  @Input() public disabled: boolean;
  @Input() public isTabActive: (tab: ITab, isActiveByDefault: boolean) => boolean;

  /**
   * The currently active tab. Can be an ITab object or the ID of the tab as a string.
   */
  @Input() public set activeTab(value: ITab | string) {
    this.hasActiveTabInput = true;

    const nextActiveTab = isString(value)
      ? find(this.tabs, (tab) => isEqual(tab.id, value))
      : value;

    this._activeTab = nextActiveTab;
  }

  public get activeTab(): ITab {
    return this._activeTab as ITab;
  }

  @Output() public tabClick: EventEmitter<ITab> = new EventEmitter<ITab>();

  protected _activeTab: ITab = null;

  /**
   * is activeTab input provided, if not, will use defaultActive tab as active tab
   */
  protected hasActiveTabInput = false;

  public constructor() {}

  public ngOnInit() {
    if (!this.hasActiveTabInput) {
      this._activeTab = find(this.tabs, (tab) => tab.defaultActive);
    }
  }

  public isActive(tab: ITab): boolean {
    const isActiveByDefault = isEqual(this.activeTab?.id, tab.id);

    if (this.isTabActive) {
      return this.isTabActive(tab, isActiveByDefault);
    }
    return isActiveByDefault;
  }

  public onTabClick(tab: ITab): void {
    if (tab.disabled) {
      return;
    }
    this._activeTab = tab;
    this.tabClick.emit(tab);
  }
}
